import { CheckCircle2 } from 'lucide-react';
import { motion } from "framer-motion";
import CTAButton from '../CTAButton';

const ServiceCategories = ({ services, title, onCategoryClick, onCtaClick }) => {
    return (
        <section id="specialized-categories" className="py-10 bg-white">
            <div className="container mx-auto px-6">
                <div className=" mx-auto text-center mb-16">
                    <h2 className="text-3xl md:text-5xl font-bold text-[#01014C] syne mb-4">
                        {title || <>Specialized <span className="text-blue-600">Staffing Solutions</span></>}
                    </h2>
                    <p className="text-slate-600 text-sm md:text-base leading-relaxed">
                        Tailored staffing categories designed to meet specific technical, leadership, and operational demands.
                    </p>
                </div>
                <div className="space-y-12">
                    {services.map((service, i) => (
                        <motion.div whileInView={{ opacity: 1, x: 0 }} initial={{ opacity: 0, x: -30 }} key={i} className="group bg-white rounded-[2.5rem] border border-blue-100/50 p-8 md:p-12 shadow-xl hover:shadow-2xl transition-all">
                            <div className="flex flex-col lg:flex-row justify-between gap-10">
                                <div className="lg:w-1/2">
                                    <h4 className="text-blue-600 text-xs mb-4 font-black uppercase tracking-wider">{service.microHeading}</h4>
                                    <h3 className="text-2xl font-bold text-slate-900 mb-6">{service.title}</h3>
                                    <p className="text-slate-500 leading-relaxed mb-8">{service.description}</p>
                                    {onCategoryClick && (
                                        <CTAButton 
                                            text={service.ctaText || `Explore ${service.title}`}
                                            onClick={() => onCategoryClick(service)}
                                            type="primary"
                                        />
                                    )}
                                </div>
                                <div className="lg:w-1/2 grid grid-cols-1 md:grid-cols-2 gap-4 bg-blue-50/20 p-8 rounded-3xl">
                                    {service.points.map((p, j) => (
                                        <div key={j} className="flex items-start gap-3 text-sm font-bold text-slate-700">
                                            <CheckCircle2 size={16} className="text-blue-500 mt-1 shrink-0" /> 
                                            <span>{p}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>

                {onCtaClick && (
                    <div className="mt-16 text-center flex justify-center">
                        <CTAButton text="Discuss Your Requirements" onClick={onCtaClick} />
                    </div>
                )}
            </div>
        </section>
    );
};

export default ServiceCategories;